<template>
  <div>
    <div
      class="modal fade"
      id="book-list-master-achieved-component"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-custom"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header bg-white justify-content-between align-items-center">
            <div class="flex-grow-1 w-0">
              <button type="button" class="btn btn-light text-black-50 pl-1" @click="close">
                <i class="icon icon-close _sm"></i>
                关闭
              </button>
            </div>
            <h5 class="modal-title text-center">科目升级！</h5>
            <div class="flex-grow-1 w-0"></div>
          </div>
          <div
            class="modal-body p-0 bg-dark text-white h-full d-flex justify-content-center align-items-center"
          >
            <div class="book-to-master-exercise py-7">
              <ul class="list-group list-group-flush">
                <li
                  class="list-group-item bg-transparent py-5 animated fadeInUp fast"
                  :style="{ 'animation-delay': `0.${idx - 1}s` }"
                  :key="`book-idx-${idx}`"
                  v-for="(book, idx) in BookList"
                >
                  <div class="media">
                    <div class="media-body align-self-center h4 mb-0">{{ book.bookName }}</div>
                    <div
                      class="book-level _master ml-7 award-zoom"
                      :class="`_v${CourseLevel+1}`"
                      :style="{ 'animation-delay': `1.${idx - 1}s` }"
                    ></div>
                  </div>
                </li>
                <!-- <li
                  class="list-group-item bg-transparent py-5 animated fadeInUp fast"
                  style="animation-delay: 0.2s"
                >
                  <div class="media">
                    <div class="media-body align-self-center h4 mb-0">book name</div>
                    <div
                      class="book-level _master _v1 ml-7 award-zoom"
                      style="animation-delay: 1.2s"
                    ></div>
                  </div>
                </li>
                <li
                  class="list-group-item bg-transparent py-5 animated fadeInUp fast"
                  style="animation-delay: 0.3s"
                >
                  <div class="media">
                    <div class="media-body align-self-center h4 mb-0">book name</div>
                    <div
                      class="book-level _master _v1 ml-7 award-zoom"
                      style="animation-delay: 1.3s"
                    ></div>
                  </div>
                </li>-->
              </ul>
              <div class="book-to-master-bg">
                <img
                  src="https://resources.pzacademy.com/image/class-ui/book-to-master-bg.svg"
                  style="opacity: 0.75"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer bg-white justify-content-between">
            <div class="modal-footer-left"></div>
            <div class="modal-footer-right">
              <button type="button" class="btn btn-primary btn-lg" @click="close">关闭</button>
              <!-- <button
                v-if="Book.nextBookName"
                type="button"
                class="btn btn-primary btn-lg"
                @click="onGoToNextBook()"
              >查看下一科目</button>-->
            </div>
          </div>
          <div class="book-master-achieved">
            <canvas style="width: 100%; height: 100%"></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';

export default {
  name: 'BookListMasterAchieved',

  props: {
    visiable: {
      type: Boolean,
      default: () => false,
    },

    onClose: {
      type: Function,
      default: () => {},
    },

    CourseLevel: {
      type: Number,
      default: () => 0,
    },

    // onGoToNextBook: {
    //   type: Function,
    //   default: () => {},
    // },

    BookList: {
      type: Array,
      default: () => [],
    },
  },

  computed: {},

  watch: {
    visiable: function (v) {
      if (v) {
        $(`#book-list-master-achieved-component`).modal({
          backdrop: 'static',
          keyboard: false,
        });
      }
    },
  },

  mounted() {
    $(`#book-list-master-achieved-component`).on('hidden.bs.modal', (e) => {
      this.onClose();
    });
  },

  beforeDestroy() {
    this.close();
  },

  methods: {
    close() {
      $(`#book-list-master-achieved-component`).modal('hide');
      this.onClose();
    },

    // goToNextBook() {
    //   this.close();
    //   this.onGoToNextBook();
    // },
  },
};
</script>
<style lang="scss" scoped>
.book-master-achieved {
  left: 0px !important;
  top: 0px !important;
  position: fixed !important;
  z-index: 200000 !important;
  pointer-events: none !important;
  width: 100%;
  height: 100%;
  right: 0px !important;
  bottom: 0px !important;
  -webkit-filter: Alpha(opacity=0) !important;
  filter: Alpha(opacity=0) !important;
}
</style>
